import React from 'react'
import styles from './scss/createcampaign.module.scss';
import ContentLayout from '../../layout/contentLayout'
import { Link } from 'react-router-dom'
import { assets } from '../../styles/assets/assets';

const CreateCampaign = () => {
    return (
        <ContentLayout noPaddingBlock={true}>
            <div className={styles.createcampaignsec}>
                <div className='breadcrumbs'>
                    <ol>
                        <li>
                            <Link to=''>Campaigns</Link>
                        </li>
                        <li>
                            Campaign Name
                        </li>
                    </ol>
                </div>
                <div className={`${styles.chatsecouter} ${styles.center}`}>
                    {/* <div className={styles.chatsec}>
                        <div className={styles.chatsecinner}>
                            <div className={styles.chatcenter}>
                                <span className={styles.headertxt}>Title</span>
                                <p>Based on Campaign Goal & Objective, Approved Templates from settings is listed Based on Campaign Goal & Objective, Approved Templates from settings is listed Based on Campaign Goal & Objective, Approved Templates from settings is listed</p>
                            </div>
                            <div className={styles.chatright}>
                                Based on Campaign Goal & Objective, Approved Templates from settings is listed
                            </div>
                        </div>
                    </div> */}
                    <div className={styles.introchat}>
                        <h2>Create campaign</h2>
                        <div className={styles.goalssec}><span>Define your Goal & Objective</span> <span>Define your Audience</span></div>
                    </div>
                    <div className={styles.inpsec}>
                        <textarea name="" id="" placeholder='Write your Goal & Objective'></textarea>
                        <img className={styles.sendarr} src={assets.sendarrow} alt="sendarrow" />
                    </div>
                </div>
            </div>
        </ContentLayout>
    )
}

export default CreateCampaign
